import Service from '../Service'
import { LandingV4Instance } from './Instance'

/**
 * @class
 */
export class CataloguesService extends Service {

  SendUrlClient(creditApplicationId, operationType,medioType, parametro) {
    let concat=''
    let concat_=''
    let param=''
    if(parametro){
      param=`&parametro=${parametro}`
    }
    if(medioType){
      concat_=`&MedioType=${medioType}`
    }
    if(operationType){
      concat=`&OperationType=${operationType}`
    }
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: `/renovaciones/EnviarLiga?creditApplicationId=${creditApplicationId}${concat}${concat_}${param}`,
    }))
  }

  SendLink(creditApplicationId, operationType, param, esIngles) {
    let params = param ? `&parametro=${encodeURIComponent(param)}` : ''
    let concat = ''
    if(operationType){
      concat = `&OperationType=${operationType}&medioType=SmsAFI`
    }
    let optln = `&optln=${esIngles}`
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: `/renovaciones/EnviarLiga?creditApplicationId=${creditApplicationId}${concat}${params}${optln}`,
    }))
  }
  
  getUpdateDataVeriCore(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({       
      method: 'POST',
      url: `/updateDataVeriCore/${creditApplicationId}`,      
    }))
  }
  getRoadmap(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({       
      method: 'GET',
      url: `/roadmap/${creditApplicationId}/VERIDENTIJUMIO/PARAM`,      
    }))
  }

  callProducts(broker,originState) {  
    let _hostName = window ? window.location.host : 'localhost'
    return this._requestWrapper(LandingV4Instance({
      method: 'GET',
      url: `/productos?hostName=${_hostName}&landingVersion=1&tenant=AFI&broker=${broker}&originState=${originState}`,      
    }))
  }


  rejectIngresoMinimo(landingApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: 'score/afi/reject',
      data: {
        creditApplicationId: landingApplicationId,
        causaRechazoId:"112"
      }
    }))
  }

  postIngresoMinimo(landingApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: '/ingresoMinimo',
      data: {creditApplicationId: landingApplicationId}
    }))
  }
  /**
   * @param {String} landingApplicationId   
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  putCanceledLead(landingApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: '/prove/cancellead',
      data: {
        creditApplicationId: landingApplicationId,
        causaRechazoId:"643",        
        causaRechazoTxt:"BLACKLIST"
      }
    }))
  }

   /**   
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getJobPosition() {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: '/catalog/jobposition'      
    }))
  }

   /**   
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getMaritalStatus(culture) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/catalog/maritalstatus/${culture}`      
    }))
  }

   /**
   * @param {String} landingApplicationId   
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  putPolicesAfi(landingApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'put',
      url: '/kyc/policies/afi',
      params: {
        creditApplicationId: landingApplicationId        
      }
    }))
  }
  /**
 * @param {String} creditApplicationId
 * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
 */
  putAgent(creditApplicationId, isMobile) {
    return this._requestWrapper(LandingV4Instance({
      method: 'put',
      url:  '/customersapp/agent',
      data:{
        creditApplicationId,
        isMobile
      } 
    }))
  }

  /**
   * @param {String} landingApplicationId
   * * @param {String} culture
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  putChangueLang(landingApplicationId, culture) {
    return this._requestWrapper(LandingV4Instance({
      method: 'put',
      url: '/language',
      params: {
        creditApplicationId: landingApplicationId,
        lang: culture
      }
    }))
  }

  /**
   * @param {String} creditApplicationId
   * * @param {String} culture
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getScoreCataloguesLang(creditApplicationId, culture) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: '/score/catalogs-language',
      params: {
        creditApplicationId,
        culture
      }
    }))
  }


  /**
 * @param  {String} NumberTel
 * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
 */
  postPhoneValidate(creditApplicationId, phoneNumber) {
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: '/validations/phone',
      data: {
        creditApplicationId: `${creditApplicationId}`,
        phoneNumber: `${phoneNumber}`,
      }
    }))
  }

  /**
* @param  {String} Email
* @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
*/
  postEmailValidate(creditApplicationId, email) {
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: '/validations/email',
      data: {
        creditApplicationId: `${creditApplicationId}`,
        email: `${email}`,
      }
    }))
  }


  /**
   * @param  {String} PostalCode
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  identityBiometrics(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      // url: '/verifications/identity-biometrics',
      url: '/startOnboardingSession',    
      data: {
        idSolicitud: creditApplicationId        
      }        
    }))
  }

  /**
   * @param  {String} creditApplicationId
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  identityVirtual(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'GET',
      url: `/verifications/identity-virtual?creditApplicationId=${creditApplicationId}`,
      // params: {
      //   creditApplicationId
      // }
    }))
  }

  /**
   * @param  {String} PostalCode
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getNeighborhoodsAfi(PostalCode) {
    return this._requestWrapper(LandingV4Instance({
      method: 'GET',
      url: '/customer/neighborhoods/afi',
      params: {
        PostalCode
      }
    }))
  }

  /**
   * @param  {String} PostalCode
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getNeighborhoods(PostalCode, creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'GET',
      url: '/customer/neighborhoods',
      params: {
        PostalCode,
        creditApplicationId
      }
    }))
  }

  /**
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  customer(tenant, creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'GET',
      url: '/customer',
      params: {
        creditApplicationId,
        tenant
      }
    }))
  }

  /**
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getStates(tenant) {
    return this._requestWrapper(LandingV4Instance({
      method: 'GET',
      url: '/customer/states',
      params: {
        tenant
      }
    }))
  }

  /**
   * @param {String} landingApplicationId
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getScoreCatalogues() {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: '/score/catalogs',
      // params: {
      //   landingApplicationId
      // }
    }))
  }

  /**
 * @param {String} creditApplicationId
 * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
 */
  getSurveys(creditApplicationId, language) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: language ? '/surveys/nps-language' : '/surveys/nps',
      params: language ? {
        creditApplicationId,
        language
      } : {
        creditApplicationId
      }
    }))
  }

  /**
   * @param {String} landingApplicationId
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getCataloguesRelationship(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: '/insurance/relationships',
      params: {
        creditApplicationId,
      }
    }))
  }
  /**
 * @param {String} creditApplicationId
 * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
 */
  getSignature(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/signature/${creditApplicationId}`,
    }))
  }

  /**
* @param {String} creditApplicationId
* @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
*/
  getPrescoreNip(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/prescore/nip?creditApplicationId=${creditApplicationId}&baseUtcOffset=-5`,
    }))
  }

  /**
 * @param {String} creditApplicationId
 * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
 */
  getPreapproved(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/preapproved`,
      params: {
        creditApplicationId,
      }
    }))
  }
  /**
   * @param {String} creditApplicationId
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getCongratulations(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/congratulations`,
      params: {
        creditApplicationId,
      }
    }))
  }

  /**
  * @param {String} creditApplicationId
  * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
  */
  getLegalesLang(creditApplicationId, lang, originState) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/legal/afi`,
      params: {
        creditApplicationId,
        lang,
        originState
      }
    }))
  }

  /**
  * @param {String} creditApplicationId
  * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
  */
  getLegales(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/legal`,
      params: {
        creditApplicationId,
      }
    }))
  }

  /**
  * @param {String} creditApplicationId
  * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
  */
  getBrokers(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/landing`,
      params: {
        creditApplicationId,
      }
    }))
  }

  /**
  * @param {String} creditApplicationId
  * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
  */
  getIncomeIngresos(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/income`,
      params: {
        creditApplicationId,
      }
    }))
  }
  /**
  * @param {String} paymentFrequencyId
  * @param {String} creditApplicationId
  * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
  */
  getIncomeSpec(paymentFrequencyId, creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/income/spec`,
      params: {
        paymentFrequencyId,
        creditApplicationId
      }
    }))
  }
  /**
  * @param {String} paymentFrequencyId
  * @param {String} creditApplicationId
  * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
  */
  getCustomerApp(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/customersapp`,
      responseType: 'blob',
      params: {
        creditApplicationId
      }
    }))
  }

  /**
  * @param {String} creditApplicationId
  * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
  */
  getReferencesCommercial(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/references/commercial`,
      params: {
        creditApplicationId,
      }
    }))
  }

  /**
   * @param {String} creditApplicationId
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  getReferencesPersonal(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/references/personal`,
      params: {
        creditApplicationId,
      }
    }))
  }


  /**
  * @param {String} creditApplicationId
  * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
  */
  getOffer(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/offer`,
      params: {
        creditApplicationId,
      }
    }))
  }

  /**
 * @param {String} medioId
 * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
 */
  getMediosFunnel(medioId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'get',
      url: `/mediosFunnel/afi`,
      params: {
        medioId
      }
    }))
  }

  cavSectionGeneric(creditApplicationId,query) {
    // const self = this
    return this._requestWrapper(LandingV4Instance({
      method: 'GET',
      url: `/cav/section?creditApplicationId=${creditApplicationId}&jsonQuery=${query}`,
      // data: self.data
    }))
  }

  postInsuranceApp(landingApplicationId,ip) {
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: '/insurance/app',
      data: {
        creditApplicationId: landingApplicationId,
        ipCliente:ip        
      }
    }))
  }

  referidosCheck(sellerPartner) {
    // const self = this
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      // url: `/establecimiento?establecimientoid=${sellerPartner}`,
      url: `/establecimiento`,
      data: {
        "establecimientoid": sellerPartner
      }
    }))
  }

  funnelErrors(jData) {
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: '/loanCenter',
      data: jData
    }))
  }

  getExpedienteDigital(creditApplicationId) {
    return this._requestWrapper(LandingV4Instance({       
      method: 'GET',
      url: `/expedienteDigital/${creditApplicationId}`,      
    }))
  }

  /**
   * @param {String} nombre
   * @param {String} apellido
   * @param {String} telefono
   * @param {String} clienteId
   * @param {String} estrategia - Parámetro opcional de la URL
   * @param {String} usuariopromotor - Parámetro opcional de la URL
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  guardaReferidos(nombre, apellido, telefono, clienteId, estrategia = '', usuariopromotor = '') {
    let urlParams = `primerNombre=${nombre}&apaterno=${apellido}&telefono=${telefono}&clienteId=${clienteId}`

    if (estrategia) {
      urlParams += `&estrategia=${estrategia}`
    }

    if (usuariopromotor) {
      urlParams += `&usuariopromotor=${usuariopromotor}`
    }

    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: `/referidos/guardar?${urlParams}`
    }))
  }

  /**
   * @param {String} clienteId
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  ofertasCampaniasCliente(clienteId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: '/clientes/ofertascampaniascliente',
      data: {
        clienteId: clienteId
      }
    }))
  }


  /**
   * @param {String} creditApplicationId
   * @param {String} status
   * @param {String} result
   * @param {String} taskId
   * @returns {Promise<import('../Service').ServiceResponse|import('../Service').ServiceError>}
   */
  actualizarVerificacion(creditApplicationId, status, result, taskId) {
    return this._requestWrapper(LandingV4Instance({
      method: 'PUT',
      url: '/actualizarverificacion',
      data: {
        creditApplicationId,
        status,
        result,
        taskId
      }
    }))
  }

  analyzeIdentityFile(imageBlob) {
    const formData = new FormData()
    formData.append('file', imageBlob, 'identity.jpg')
    return this._requestWrapper(LandingV4Instance({
      method: 'POST',
      url: '/analyzeIdentityFile',
      data: formData,
    }))
  }

}